/**
 * A two-line table cell: a primary value with a related secondary one beneath.
 *
 * Only for genuinely related pairs — sub ref / customer ref, supplier / their
 * code, sample / bulk lead time. Stacking unrelated values to save width makes
 * a table harder to read, not denser, so the component takes exactly two slots
 * and nothing more.
 */
export function Stack({
  top,
  bottom,
  mono = false,
  monoTop = false,
  align = "left",
}: {
  top: string | null | undefined;
  bottom: string | null | undefined;
  /** Tabular mono on both lines — for codes and numbers. */
  mono?: boolean;
  /** Tabular mono on the top line only — e.g. a date above an author. */
  monoTop?: boolean;
  align?: "left" | "right";
}) {
  const monoCls = "font-mono tabular";
  const alignCls = align === "right" ? "text-right" : "";
  return (
    <div className={`min-w-0 overflow-hidden ${alignCls}`}>
      <div
        className={`truncate text-xs text-ink-soft ${mono || monoTop ? monoCls : ""}`}
      >
        {top?.trim() ? top : "—"}
      </div>
      {bottom?.trim() ? (
        <div className={`truncate text-2xs text-ink-faint ${mono ? monoCls : ""}`}>
          {bottom}
        </div>
      ) : null}
    </div>
  );
}
